import React from "react"

export const HambergerIconColor = ({color}) => {
    return (
        <svg width="40px" height="40px" viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="PC/btn/gnb_menu_40" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <rect id="Rectangle" x="0" y="0" width="40" height="40"></rect>
                <rect id="Rectangle" fill={color} x="5" y="15" width="30" height="2"></rect>
                <rect id="Rectangle-Copy" fill={color} x="5" y="24" width="30" height="2"></rect>
            </g>
        </svg>
    )
}
